import { BaseResource } from "./base.resource";

export const SourceCodeAccessLevel = {
  None: 0,
  View: 1 << 0,
  Edit: 1 << 1,
  Delete: 1 << 2,
};

export class SourceCode extends BaseResource {
  active: boolean;
  code: string;
  description: string;

  constructor(options?: any) {
    super(options);
    // Initialize properties...
  }

  get canView(): boolean {
    return (this.accessLevel & SourceCodeAccessLevel.View) > 0;
  }
  get canEdit(): boolean {
    return (this.accessLevel & SourceCodeAccessLevel.Edit) > 0;
  }
  get canDelete(): boolean {
    return (this.accessLevel & SourceCodeAccessLevel.Delete) > 0;
  }
}
